export default __webpack_public_path__ + "static/media/doggle_3_1.7531e733.png";